module.exports = __webpack_public_path__ + "fonts/remote-class-inst.png!static";